<div class="wrap">
  <header>
    <img title="Orbitax" src="https://dev-partners-wordpress-backup.s3.us-west-2.amazonaws.com/wp-content/uploads/2024/06/12171034/orbitax_logo_dark.svg" alt="Orbitax Logo">
  </header>

  <div *ngIf="preferenceData as pref; else errorBox" class="email-preferences-container">
    <h1>Email Preferences</h1>
    <p>Update your Orbitax Email Preferences</p>

    <div class="table-container">
      <table>
        <tr>
          <th>Notice</th>
          <th>Email Inbox</th>
        </tr>

        <tr *ngFor="let preference of pref.notificationPreferences; let i = index">
          <td>
            <div class="second-header-text">{{ preference.title }}</div>
            <span class="description">{{ preference.description }}.</span>
          </td>
          <td>
            <mat-form-field class="pref-select" appearance="outline">
              <mat-select
                [(ngModel)]="preference.selectedPreference.id"
                (selectionChange)="onSelectionChange($event, i)"
                [title]="preference.selectedPreference.displayText"
                panelClass="pref-panel">
                <mat-option
                  *ngFor="let option of preference.preferenceOptions"
                  [value]="option.id"
                  [title]="option.displayText">
                  {{ option.displayText }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </div>

    <div class="button-container w-p-100">
      <div class="blue-box-container">
        <span>Note: </span>You will always receive essential emails such as changes to your accounts or license.
      </div>
      <button
        mat-button
        class="action-button w-p-100"
        type="button"
        (click)="updatePreference()">
        Update my preferences
      </button>
    </div>
  </div>

  <ng-template #errorBox>
    <div class="blue-box-container text-center">
      <span>Note: </span>
      <ng-container *ngIf="loadError || !paramAvailability; else genericErr">
        Unable to load your preferences. Please check your link or try again.
      </ng-container>
      <ng-template #genericErr>Sorry, Something is wrong.</ng-template>
    </div>
  </ng-template>
</div>
